"use strict";

var _toConsumableArray = require("/Users/macbook/Documents/apps/nico_frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/Users/macbook/Documents/apps/nico_frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactMultiEmail = void 0;
var React = __importStar(require("react"));
var isEmail_1 = require("./isEmail");
var initialEmailAddress = function initialEmailAddress(emails) {
  if (typeof emails === 'undefined') return [];
  var validEmails = emails.filter(function (email) {
    return (0, isEmail_1.isEmail)(email);
  });
  return validEmails;
};
function ReactMultiEmail(props) {
  var _this = this;
  var id = props.id,
    style = props.style,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    noClass = props.noClass,
    placeholder = props.placeholder,
    autoFocus = props.autoFocus,
    _props$allowDisplayNa = props.allowDisplayName,
    allowDisplayName = _props$allowDisplayNa === void 0 ? false : _props$allowDisplayNa,
    _props$stripDisplayNa = props.stripDisplayName,
    stripDisplayName = _props$stripDisplayNa === void 0 ? false : _props$stripDisplayNa,
    _props$allowDuplicate = props.allowDuplicate,
    allowDuplicate = _props$allowDuplicate === void 0 ? false : _props$allowDuplicate,
    _props$delimiter = props.delimiter,
    delimiter = _props$delimiter === void 0 ? "[".concat(allowDisplayName ? '' : ' ', ",;]") : _props$delimiter,
    _props$initialInputVa = props.initialInputValue,
    initialInputValue = _props$initialInputVa === void 0 ? '' : _props$initialInputVa,
    inputClassName = props.inputClassName,
    autoComplete = props.autoComplete,
    getLabel = props.getLabel,
    enable = props.enable,
    onDisabled = props.onDisabled,
    validateEmail = props.validateEmail,
    onChange = props.onChange,
    onChangeInput = props.onChangeInput,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onKeyDown = props.onKeyDown,
    onKeyUp = props.onKeyUp,
    spinner = props.spinner,
    _props$disableOnBlurV = props.disableOnBlurValidation,
    disableOnBlurValidation = _props$disableOnBlurV === void 0 ? false : _props$disableOnBlurV;
  var emailInputRef = React.useRef(null);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focused = _React$useState2[0],
    setFocused = _React$useState2[1];
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    emails = _React$useState4[0],
    setEmails = _React$useState4[1];
  var _React$useState5 = React.useState(initialInputValue),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    inputValue = _React$useState6[0],
    setInputValue = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    spinning = _React$useState8[0],
    setSpinning = _React$useState8[1];
  var findEmailAddress = React.useCallback(function (value, isEnter) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _a, _b, validEmails, inputValue, re, isEmail, addEmails, setArr, arr, validateResult, validateResultWithDisplayName, email, _validateResult, _validateResultWithDisplayName, _email;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            validEmails = [];
            inputValue = '';
            re = new RegExp(delimiter, 'g');
            isEmail = validateEmail || isEmail_1.isEmail;
            addEmails = function addEmails(email) {
              if (!allowDuplicate) {
                for (var i = 0, l = emails.length; i < l; i++) {
                  if (emails[i] === email) {
                    return false;
                  }
                }
              }
              validEmails.push(email);
              return true;
            };
            if (!(value !== '')) {
              _context.next = 49;
              break;
            }
            if (!re.test(value)) {
              _context.next = 27;
              break;
            }
            setArr = new Set(value.split(re).filter(function (n) {
              return n;
            }));
            arr = _toConsumableArray(setArr);
          case 9:
            validateResult = isEmail('' + arr[0].trim());
            if (!(typeof validateResult === 'boolean')) {
              _context.next = 14;
              break;
            }
            if (validateResult) {
              addEmails('' + ((_a = arr.shift()) === null || _a === void 0 ? void 0 : _a.trim()));
            } else {
              if (allowDisplayName) {
                validateResultWithDisplayName = isEmail('' + arr[0].trim(), {
                  allowDisplayName: allowDisplayName
                });
                if (validateResultWithDisplayName) {
                  // Strip display name from email formatted as such "First Last <first.last@domain.com>"
                  email = stripDisplayName ? (_b = arr.shift()) === null || _b === void 0 ? void 0 : _b.split("<")[1].split(">")[0] : arr.shift();
                  addEmails('' + email);
                } else {
                  if (arr.length === 1) {
                    inputValue = '' + arr.shift();
                  } else {
                    arr.shift();
                  }
                }
              } else {
                inputValue = '' + arr.shift();
              }
            }
            _context.next = 24;
            break;
          case 14:
            // handle promise
            setSpinning(true);
            _context.next = 17;
            return validateEmail === null || validateEmail === void 0 ? void 0 : validateEmail(value);
          case 17:
            _context.t0 = _context.sent;
            if (!(_context.t0 === true)) {
              _context.next = 23;
              break;
            }
            addEmails('' + arr.shift());
            setSpinning(false);
            _context.next = 24;
            break;
          case 23:
            if (arr.length === 1) {
              inputValue = '' + arr.shift();
            } else {
              arr.shift();
            }
          case 24:
            if (arr.length) {
              _context.next = 9;
              break;
            }
          case 25:
            _context.next = 49;
            break;
          case 27:
            if (!(enable && !enable({
              emailCnt: emails.length
            }))) {
              _context.next = 30;
              break;
            }
            onDisabled === null || onDisabled === void 0 ? void 0 : onDisabled();
            return _context.abrupt("return");
          case 30:
            if (!isEnter) {
              _context.next = 48;
              break;
            }
            _validateResult = isEmail(value);
            if (!(typeof _validateResult === 'boolean')) {
              _context.next = 36;
              break;
            }
            if (_validateResult) {
              addEmails(value);
            } else if (allowDisplayName) {
              _validateResultWithDisplayName = isEmail(value, {
                allowDisplayName: allowDisplayName
              });
              if (_validateResultWithDisplayName) {
                // Strip display name from email formatted as such "First Last <first.last@domain.com>"
                _email = stripDisplayName ? value.split('<')[1].split('>')[0] : value;
                addEmails(_email);
              } else {
                inputValue = value;
              }
            } else {
              inputValue = value;
            }
            _context.next = 46;
            break;
          case 36:
            // handle promise
            setSpinning(true);
            _context.next = 39;
            return validateEmail === null || validateEmail === void 0 ? void 0 : validateEmail(value);
          case 39:
            _context.t1 = _context.sent;
            if (!(_context.t1 === true)) {
              _context.next = 45;
              break;
            }
            addEmails(value);
            setSpinning(false);
            _context.next = 46;
            break;
          case 45:
            inputValue = value;
          case 46:
            _context.next = 49;
            break;
          case 48:
            inputValue = value;
          case 49:
            setEmails([].concat(_toConsumableArray(emails), validEmails));
            setInputValue(inputValue);
            if (validEmails.length) {
              onChange === null || onChange === void 0 ? void 0 : onChange([].concat(_toConsumableArray(emails), validEmails));
            }
            if (inputValue !== inputValue) {
              onChangeInput === null || onChangeInput === void 0 ? void 0 : onChangeInput(inputValue);
            }
          case 53:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }, [allowDisplayName, allowDuplicate, delimiter, emails, enable, onChange, onChangeInput, onDisabled, stripDisplayName, validateEmail]);
  var onChangeInputValue = React.useCallback(function (value) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return findEmailAddress(value);
          case 2:
            onChangeInput === null || onChangeInput === void 0 ? void 0 : onChangeInput(value);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  }, [findEmailAddress, onChangeInput]);
  var removeEmail = React.useCallback(function (index, isDisabled) {
    if (isDisabled) {
      return;
    }
    var _emails = [].concat(_toConsumableArray(emails.slice(0, index)), _toConsumableArray(emails.slice(index + 1)));
    setEmails(_emails);
    onChange === null || onChange === void 0 ? void 0 : onChange(_emails);
  }, [emails, onChange]);
  var handleOnKeydown = React.useCallback(function (e) {
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    switch (e.key) {
      case 'Enter':
        e.preventDefault();
        break;
      case 'Backspace':
        if (!e.currentTarget.value) {
          removeEmail(emails.length - 1, false);
        }
        break;
      default:
    }
  }, [emails.length, onKeyDown, removeEmail]);
  var handleOnKeyup = React.useCallback(function (e) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(e);
            _context3.t0 = e.key;
            _context3.next = _context3.t0 === 'Enter' ? 4 : 7;
            break;
          case 4:
            _context3.next = 6;
            return findEmailAddress(e.currentTarget.value, true);
          case 6:
            return _context3.abrupt("break", 7);
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
  }, [findEmailAddress, onKeyUp]);
  var handleOnChange = React.useCallback(function (e) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return onChangeInputValue(e.currentTarget.value);
          case 2:
            return _context4.abrupt("return", _context4.sent);
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
  }, [onChangeInputValue]);
  var handleOnBlur = React.useCallback(function (e) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            setFocused(false);
            if (disableOnBlurValidation) {
              _context5.next = 4;
              break;
            }
            _context5.next = 4;
            return findEmailAddress(e.currentTarget.value, true);
          case 4:
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
          case 5:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
  }, [disableOnBlurValidation, findEmailAddress, onBlur]);
  var handleOnFocus = React.useCallback(function () {
    setFocused(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus();
  }, [onFocus]);
  React.useEffect(function () {
    setEmails(initialEmailAddress(props.emails));
  }, [props.emails]);
  return React.createElement("div", {
    className: "".concat(className, " ").concat(noClass ? '' : 'react-multi-email', " ").concat(focused ? 'focused' : '', " ").concat(inputValue === '' && emails.length === 0 ? 'empty' : ''),
    style: style,
    onClick: function onClick() {
      var _a;
      return (_a = emailInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, spinning && (spinner === null || spinner === void 0 ? void 0 : spinner()), placeholder ? React.createElement("span", {
    "data-placeholder": true
  }, placeholder) : null, React.createElement("div", {
    className: 'data-labels',
    style: {
      opacity: spinning ? 0.45 : 1.0,
      display: 'contents',
      flexWrap: 'inherit'
    }
  }, emails.map(function (email, index) {
    return getLabel(email, index, removeEmail);
  })), React.createElement("input", {
    id: id,
    style: {
      opacity: spinning ? 0.45 : 1.0
    },
    ref: emailInputRef,
    type: 'text',
    value: inputValue,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    onChange: handleOnChange,
    onKeyDown: handleOnKeydown,
    onKeyUp: handleOnKeyup,
    autoFocus: autoFocus,
    className: inputClassName,
    autoComplete: autoComplete
  }));
}
exports.ReactMultiEmail = ReactMultiEmail;